import { useLocation, useNavigate } from "@tanstack/react-router";
import { useRef } from "react";
import { useMutation, useQueryClient } from "react-query";

import { useModal } from "@/react/components/Layout/ModalManagerProvider";
import {
  partnerProgramMutationKeys,
  partnerProgramMutations,
  partnerProgramQueries,
} from "@/react/lib/queries/partnerProgram";

import { PARTNER_PROGRAM_PATH } from "./constants";
import { ManagedPartnerOnboardingModal } from "./ManagedPartnerOnboardingModal";

export const usePartnerOnboardingModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const { mutate: enroll } = useMutation(partnerProgramMutations.enroll());
  const isStartingRef = useRef(false);
  const modal = useModal(ManagedPartnerOnboardingModal);

  const goToPartnerProgram = () => {
    void navigate({
      to: PARTNER_PROGRAM_PATH,
      state: {
        from: { pathname: location.pathname, search: location.searchStr },
      },
    });
  };

  const startPartnerOnboarding = async () => {
    if (isStartingRef.current) return;
    isStartingRef.current = true;

    try {
      const details = await queryClient
        .fetchQuery(partnerProgramQueries.details())
        .catch(() => null);

      if (details?.enrolled) {
        goToPartnerProgram();
        return;
      }

      const isEnrolling =
        queryClient.isMutating({
          mutationKey: partnerProgramMutationKeys.enroll,
        }) > 0;
      if (!isEnrolling) enroll();
      void modal.show({ onComplete: goToPartnerProgram });
    } finally {
      isStartingRef.current = false;
    }
  };

  return { startPartnerOnboarding };
};
